module.exports = __webpack_public_path__ + "494cd07c/img/print-icon.d8dbbca5.svg";